// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2o7Op","upload":"Small_upload__W2bvz","imageWrap":"Small_imageWrap__8GlXG","removeBtn":"Small_removeBtn__EcLkj"};